import { render, staticRenderFns } from "./PollQuestion.vue?vue&type=template&id=39dfa6b8&"
import script from "./PollQuestion.vue?vue&type=script&lang=js&"
export * from "./PollQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PollQuestion.vue?vue&type=style&index=0&id=39dfa6b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports